import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../images/bubble-logo.png';
import styles from './Email.module.css';

// Adds a <meta> tag for the lifetime of the page and restores any previous value.
const useMetaTag = (name, content) => {
  useEffect(() => {
    let tag = document.querySelector(`meta[name="${name}"]`);
    const created = !tag;
    const previous = tag ? tag.getAttribute('content') : null;
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
    return () => {
      if (created) tag.remove();
      else tag.setAttribute('content', previous);
    };
  }, [name, content]);
};

const EmailPageShell = ({ title, children }) => {
  // Links on these pages carry a private token: keep them out of search engines
  // and out of the Referer header sent to other sites.
  useMetaTag('robots', 'noindex, nofollow');
  useMetaTag('referrer', 'no-referrer');

  useEffect(() => {
    const prev = document.title;
    document.title = `${title} | Bubble Ai`;
    return () => { document.title = prev; };
  }, [title]);

  return (
    <main className={styles.page}>
      <Link to="/" className={styles.logoLink} aria-label="Bubble Ai home">
        <img src={logoImg} alt="Bubble Ai" className={styles.logo} />
      </Link>
      <section className={styles.card}>{children}</section>
      <p className={styles.footer}>
        Bubble Ai will always send essential account emails such as security alerts and receipts.
        <br />
        Questions? <Link to="/support">Contact support</Link> · <Link to="/privacy">Privacy</Link>
      </p>
    </main>
  );
};

export default EmailPageShell;
